/** @format */

import { TRoom } from '@/@ducks/room/declarations';

export const utilityFormatPhoto = (raw: string) => {
  return raw;
};

interface utilityGetRoomPicturesProps {
  media: TRoom['media'];
}

export const utilityGetRoomPictures = ({ media }: utilityGetRoomPicturesProps) => {
  let photos = media?.filter(e => e.type === 'image' && e.label.toLowerCase() !== 'planimetry');
  const photosLowQuality = photos?.map(photo => {
    const srcImage = photo?.altThumbnail || photo?.thumbnail || photo?.url;
    return utilityFormatPhoto(srcImage);
  });
  const photosHighQuality = photos?.map(photo => utilityFormatPhoto(photo?.altUrl || photo?.url));
  const itemVR = media?.find(photo => photo?.type === 'vr');
  const itemPlanimetry = media?.find(
    photo => photo.type === 'planimetry' || photo.label.toLowerCase() === 'planimetry',
  );

  return {
    hasMultiplePhotos: photos?.length > 1,
    photosLowQuality,
    photosHighQuality,
    urlVR: itemVR?.url,
    urlPlanimetry: itemPlanimetry?.url,
    hasPlanimetry: !!itemPlanimetry,
    hasVR: !!itemVR,
  };
};
